import { Image, message } from "antd";
import axios from "axios";
import { create } from "zustand";
import { MAIN_URL } from "../../../Constants";

export const useManufacturer = create((set, get) => ({
    manufacturers: [],
    ed: {},
    setEd: (v) => {
        set({ ed: v })
    },
    columns: [
        {
            title: "Logotip",
            dataIndex: 'logo',
            key: 'logo',
            render: (logo) => <Image width={64} height={64} src={MAIN_URL + '/' + logo} style={{ objectFit: 'contain' }} />
        },
        {
            title: 'Nomi',
            dataIndex: 'nameuz',
            key: 'nameuz'
        },
        {
            title: 'Nomi',
            dataIndex: 'nameru',
            key: 'nameru'
        },
        {
            title: "Davlat",
            dataIndex: 'country',
            key: 'country',
        }
    ],
    getManufacturer: () => {
        axios.get('/manufacturers').then(res => {
            set({ manufacturers: res.data })
        }).catch(error => {
            message.error("Ma'lumotlarni olishda muammo yuzaga keldi!!!")
        })
    },
    updateManufacturer: (v) => {
        axios.put('/manufacturers/' + v.id, v).then(res => {
            get().getManufacturer()
            message.success("Muvaffaqiyatli o'zgartirdingiz!")
        }).catch(error => {
            message.error("Ma'lumotlarni o'zgartirishda muammo yuzaga keldi!!!")
        })
    },
    deleteManufacturer: (id) => {
        axios.delete('/manufacturers/' + id).then(res => {
            get().getManufacturer()
            message.success("Muvaffaqiyatli o'chirdingiz!")
        }).catch(error => {
            message.error("Ma'lumotlarni o'chirishda muammo yuzaga keldi!!!")
        })
    },
    createManufacturer: (v) => {
        axios.post('/manufacturers', v).then(res => {
            get().getManufacturer()
            message.success("Muvaffaqiyatli qo'shildingiz!")
        }).catch(error => {
            message.error("Ma'lumotlarni qo'shishda muammo yuzaga keldi!!!")
        })
    },

}))